var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer32(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.455,
    height: 23.485,
    viewBox: "0 0 23.455 23.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32",
    "data-name": "Layer 32",
    transform: "translate(-10.554 -10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M30.085,15.219v-3.9a.819.819,0,0,0-1.638,0v3.9a3.315,3.315,0,0,0,0,6.412V33.166a.819.819,0,1,0,1.638,0V21.631A3.317,3.317,0,0,0,30.085,15.219ZM29.266,20.1a1.677,1.677,0,1,1,1.581-1.674A1.677,1.677,0,0,1,29.266,20.1Z",
    transform: "translate(-6.999)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M48.016,22.242a3.315,3.315,0,0,0-2.49-3.206V11.319a.819.819,0,0,0-1.638,0v7.717a3.315,3.315,0,0,0,0,6.412v7.717a.819.819,0,1,0,1.638,0V25.448A3.315,3.315,0,0,0,48.016,22.242Zm-3.277,1.671a1.671,1.671,0,1,0-.022,0Z",
    transform: "translate(-14.006)",
    fill: "#9a82b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M14.654,24.973V11.319a.819.819,0,0,0-1.638,0V24.973a3.315,3.315,0,0,0,0,6.406v1.786a.819.819,0,1,0,1.638,0v-1.78a3.315,3.315,0,0,0,0-6.412Zm-.819,4.883a1.677,1.677,0,0,1,0-3.348,1.677,1.677,0,0,1,0,3.348Z",
    fill: "#9a82b8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer32);
export default __webpack_public_path__ + "static/media/Layer 32.5a6b704e9c67a761f00b81b0ce36fb9d.svg";
export { ForwardRef as ReactComponent };